module.exports = __webpack_public_path__ + "img/39.39f4385e.svg";